import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDataByUniqueModalName } from '../../Modal/modalViewState';
import { toggleModal } from '../../Modal/modalActions';
import { getIsPrevetFormUpdateLoading, getPrevetFormUpdateError, getIsPrevetFormUpdateSuccess, getPrevetFormUpdatePrevetId } from './prevetFormEntity';
import { toastIfError } from '../../../utils/toast';
import PrevetForm from './PrevetForm';
import './EditPrevetForm.scss';

export class EditPrevetForm extends Component {
    static propTypes = {
        prevetData: PropTypes.object,
        isUpdateLoading: PropTypes.bool,
        updateError: PropTypes.string,
        isUpdateSuccessful: PropTypes.bool,
        updatePrevetId: PropTypes.number,
        onToggleModal: PropTypes.func.isRequired
    };

    componentDidUpdate(previousProps) {
        toastIfError(previousProps, this.props, 'updateError');
    }

    render() {
        return (
            <PrevetForm
                isEditMode={true}
                initialValues={this.props.prevetData}
                isSubmitting={this.props.isUpdateLoading}
                error={this.props.updateError}
                submitSuccess={this.props.isUpdateSuccessful}
                updatedPrevetId={this.props.updatePrevetId}
                onToggleModal={this.props.onToggleModal}
                showInModal={true}
                modalTitle="Edit Pre-Vet Form"
                uniqueModalName="editPrevet"
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        prevetData: getDataByUniqueModalName(state, 'editPrevet'),
        isUpdateLoading: getIsPrevetFormUpdateLoading(state),
        updateError: getPrevetFormUpdateError(state),
        isUpdateSuccessful: getIsPrevetFormUpdateSuccess(state),
        updatePrevetId: getPrevetFormUpdatePrevetId(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onToggleModal: (modalName) => dispatch(toggleModal(modalName))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPrevetForm);
